import styled from '@emotion/styled';

export const ContentWrapper = styled.div`
    width: 100%;
    display: inline-grid;
    grid-template-columns: 2fr auto 1fr;
    column-gap: 0.3rem;
`;

export const InfoOriginalNameWrapper = styled.div`
    margin-bottom: 0.5rem;
    align-self: end;
    justify-content: space-between;
    font-size: small;
    grid-column: span 3;
`;

export const InfoTextWrapper = styled.div`
    align-self: end;
    justify-content: space-between;
    font-size: small;
    margin-bottom: 0;
`;

export const TextWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: small;
    margin-bottom: 0;
`;
